import React from 'react'
import { BlogPostFormData } from '../../hooks/useBlogPostForm'

interface FormFieldsProps {
  formData: BlogPostFormData
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void
  generateSlug: () => void
}

const FormFields: React.FC<FormFieldsProps> = ({ formData, handleChange, generateSlug }) => {
  return (
    <>
      <div className='mb-4'>
        <label htmlFor='title' className='form-label'>Tytuł *</label>
        <input
          type='text'
          className='form-control'
          id='title'
          name='title'
          value={formData.title}
          onChange={handleChange}
          required
        />
      </div>

      <div className='mb-4'>
        <label htmlFor='slug' className='form-label'>
          Slug (URL) *
          <button
            type='button'
            className='btn btn-sm btn-outline-secondary ms-2'
            onClick={generateSlug}
            disabled={!formData.title}
          >
            Wygeneruj ze tytułu
          </button>
        </label>
        <input
          type='text'
          className='form-control'
          id='slug'
          name='slug'
          value={formData.slug}
          onChange={handleChange}
          required
        />
        <small className='form-text text-muted'>
          Slug to przyjazny dla URL identyfikator artykułu, używany w adresie strony.
        </small>
      </div>

      <div className='mb-4'>
        <label htmlFor='description' className='form-label'>Opis skrócony *</label>
        <textarea
          className='form-control'
          id='description'
          name='description'
          rows={3}
          value={formData.description}
          onChange={handleChange}
          required
        />
      </div>

      <div className='mb-4'>
        <label htmlFor='content' className='form-label'>Treść artykułu *</label>
        <textarea
          className='form-control'
          id='content'
          name='content'
          rows={10}
          value={formData.content}
          onChange={handleChange}
          required
        />
        <small className='form-text text-muted'>
          Możesz używać tagów HTML do formatowania treści.
        </small>
      </div>

      <div className='mb-4'>
        <label htmlFor='date' className='form-label'>Data publikacji *</label>
        <input
          type='date'
          className='form-control'
          id='date'
          name='date'
          value={formData.date}
          onChange={handleChange}
          required
        />
      </div>

      <div className='mb-4 form-check'>
        <input
          type='checkbox'
          className='form-check-input'
          id='published'
          name='published'
          checked={formData.published}
          onChange={handleChange}
        />
        <label className='form-check-label' htmlFor='published'>
          Opublikowany
        </label>
      </div>
    </>
  )
}

export default FormFields
